import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { toast } from 'sonner';

export const useManageReferralValidity = () => {
  const { mutateAsync, isPending } = useMutation('manageReferralValidity', {
    onSuccess: (response) => {
      toast.success(response.message);
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};
